import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotificationService } from './services/notification/notification.service';
import { ModalService } from './services/modal/modal.service';
import { StorageService } from './services/storage/storage.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';
import { UserService } from './services/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private notifService: NotificationService,
    private modalService: ModalService,
    private storageService: StorageService,
    private userService: UserService
  ) {
    // Listen for app state changes
    App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) {
        // App became active (opened)
        this.userService.updateLastOnline().subscribe();
      }
    });
  }

  initaited = false;

  async ngOnInit(){
    await SplashScreen.hide();

    if (!this.initaited){
      this.notifService.initNotifs();

      const hideIntro = await(this.storageService.get('hideIntro'))
      if (hideIntro !== 'true'){
        this.modalService.openIntro()
        this.storageService.set('hideIntro', 'true')
      }
      this.initaited = true;
    }
  }

  ngOnDestroy() {
    // Update lastOnline when app is closed
    this.userService.updateLastOnline().subscribe();
  }
}
